// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3n50b","content":"LayoutSettings_content__1Pcbb"};